import * as Types from './dashboardActionTypes.js'

const initialState = {
    statusBoard: true,
    shiftPerformanceBoard: true,
    OEEBoard: true,
    progressionBoard: true,
    messagesBoard: true,
    dashboardConfigurationDrawerOpen: false,
    timers: [],
    progressions: []
};

export default function nav(state = initialState, action) {
    switch (action.type) {
        case Types.TOGGLE_STATUSBOARD:
            if (state.statusBoard !== action.statusBoard) {
                return Object.assign({}, state, { statusBoard: action.statusBoard });
            }
            return state;
        case Types.TOGGLE_SHIFTPERFORMANCEBOARD:
            if (state.shiftPerformanceBoard !== action.shiftPerformanceBoard) {
                return Object.assign({}, state, { shiftPerformanceBoard: action.shiftPerformanceBoard });
            }
            return state;
        case Types.TOGGLE_OEEBOARD:
            if (state.OEEBoard !== action.OEEBoard) {
                return Object.assign({}, state, { OEEBoard: action.OEEBoard });
            }
            return state;
        case Types.TOGGLE_PROGRESSIONBOARD:
            if (state.progressionBoard !== action.progressionBoard) {
                return Object.assign({}, state, { progressionBoard: action.progressionBoard });
            }
            return state;
        case Types.TOGGLE_MESSAGESBOARD:
            if (state.messagesBoard !== action.messagesBoard) {
                return Object.assign({}, state, { messagesBoard: action.messagesBoard });
            }
            return state;
        case Types.SET_DASHBOARDCONFIGURATIONDRAWEROPEN:
            if (state.dashboardConfigurationDrawerOpen !== action.dashboardConfigurationDrawerOpen) {
                return Object.assign({}, state, { dashboardConfigurationDrawerOpen: action.dashboardConfigurationDrawerOpen });
            }
            return state;
        case Types.SET_TIMERS:
            if (state.timers !== action.timers) {
                return Object.assign({}, state, { timers: action.timers });
            }
            return state;
        case Types.SET_PROGRESSIONS:
            if (state.progressions !== action.progressions) {
                return Object.assign({}, state, { progressions: action.progressions });
            }
            return state;
        default:
            return state;
    }
}